export function getBoondParentID(cookie = '') {
    const iFrameCookie = cookie
        .split('; ')
        .find((row) => row.startsWith('iFrameID='));

    return iFrameCookie ? iFrameCookie.split('=')[1] : null;
}

export function initBoondIframeSdk(boondManager, parentID) {
    return boondManager.init({
        mainDivId: 'main',
        targetOrigin: '*',
        parentID,
    });
}
